import { render } from "./ChipConceptPage.vue?vue&type=template&id=64cae645&scoped=true"
import script from "./ChipConceptPage.vue?vue&type=script&lang=js"
export * from "./ChipConceptPage.vue?vue&type=script&lang=js"

import "./ChipConceptPage.vue?vue&type=style&index=0&id=64cae645&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cae645"]])

export default __exports__